// ✅ Utility functions để validate completion status

/**
 * Kiểm tra xem một scenario đã hoàn thành đầy đủ chưa
 * @param {Object} scenarioResults - Kết quả của scenario
 * @param {boolean} scenarioCompleted - Flag hoàn thành của scenario
 * @returns {boolean} - True nếu scenario đã hoàn thành đầy đủ
 */
export const isScenarioFullyComplete = (scenarioResults, scenarioCompleted) => {
  if (!scenarioResults) {
    console.warn('⚠️ Scenario results is null/undefined');
    return false;
  }

  // ✅ Chỉ khi cả reading và writing đều hoàn thành thì mới true
  const hasReading = scenarioResults.readingCompleted === true;
  const hasWriting = scenarioResults.writingCompleted === true;

  if (!hasReading) {
    console.log('❌ Scenario chưa hoàn thành phần Reading');
    return false;
  }

  if (!hasWriting) {
    console.log('❌ Scenario chưa hoàn thành phần Writing');
    return false;
  }

  // ✅ Cả hai phần đều hoàn thành
  return true;
};


/**
 * Kiểm tra xem cả 2 scenario đã hoàn thành chưa
 * @param {Object} scenario1Results - Kết quả scenario 1
 * @param {boolean} scenario1Completed - Flag hoàn thành scenario 1
 * @param {Object} scenario2Results - Kết quả scenario 2
 * @param {boolean} scenario2Completed - Flag hoàn thành scenario 2
 * @returns {boolean} - True nếu cả 2 scenario đã hoàn thành
 */
export const areBothScenariosComplete = (
  scenario1Results,
  scenario1Completed,
  scenario2Results,
  scenario2Completed
) => {
  const s1Complete = isScenarioFullyComplete(scenario1Results, scenario1Completed);
  const s2Complete = isScenarioFullyComplete(scenario2Results, scenario2Completed);

  if (!s1Complete || !s2Complete) {
    console.log('⚠️ Không đủ điều kiện hiển thị kết quả cuối: ', {
      s1Complete,
      s2Complete
    });
  }

  return s1Complete && s2Complete;
};


/**
 * Validate dữ liệu scenario result
 * @param {Object} results - Dữ liệu kết quả
 * @param {number} scenarioNumber - Số thứ tự scenario
 * @returns {boolean} - True nếu dữ liệu hợp lệ
 */
export const validateScenarioResults = (results, scenarioNumber) => {
  if (!results) {
    console.error(`Scenario ${scenarioNumber}: Results is null/undefined`);
    return false;
  }

  if (typeof results.scenario !== 'number' || results.scenario !== scenarioNumber) {
    console.error(`Scenario ${scenarioNumber}: Invalid scenario number`);
    return false;
  }

  if (typeof results.readingScore !== 'number' || results.readingScore < 0) {
    console.error(`Scenario ${scenarioNumber}: Invalid reading score`);
    return false;
  }

  if (typeof results.writingScore !== 'number' || results.writingScore < 0) {
    console.error(`Scenario ${scenarioNumber}: Invalid writing score`);
    return false;
  }

  return true;
};
